import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

type ReportDatePickerProps = {
  selected: Date | null
  onChange: (date: Date) => void
}

const ReportDatePicker = ({ selected, onChange }: ReportDatePickerProps) => {
  return (
    <div className='mb-2 custom-datepicker'>
      <DatePicker
        selected={selected}
        onChange={(date: Date | null) => {
          if (!date) return
          onChange(date)
        }}
        dateFormat='dd/MM/yyyy'
        className='form-control'
        wrapperClassName='react-datepicker-wrapper'
        popperPlacement='bottom-start'
        autoComplete='off'
      />
      <i className='far fa-calendar'></i>
    </div>
  )
}

export default ReportDatePicker
